var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8dea"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8dea"] = parcelRequire;
}
parcelRequire("ic7rk");
class $d529ab21baf1a41a$var$Slider {
    _slides = document.querySelectorAll(".slide");
    _btnPrev = document.querySelector(".slider__arrow--prev");
    _btnNext = document.querySelector(".slider__arrow--next");
    _dots = document.querySelector(".dots");
    _currentSlide = 0;
    _maxSlide = this._slides.length;
    _time = null;
    constructor(){
        this._btnNext.addEventListener("click", this.nextSlide.bind(this));
        this._btnPrev.addEventListener("click", this.prevSlide.bind(this));
        this.setSlide(this._currentSlide);
        this.createDots();
        this.dotActivation(this._currentSlide);
        document.addEventListener("keydown", this.keydownHandler.bind(this));
    }
    setSlide(slide) {
        this._slides.forEach((s, index)=>s.style.transform = `translateX(${100 * (index - slide)}%)`);
        clearTimeout(this._time);
        this._time = setTimeout(()=>{
            this.nextSlide();
            console.log(this._time);
        }, 6000);
    }
    nextSlide() {
        if (this._currentSlide === this._maxSlide - 1) this._currentSlide = 0;
        else this._currentSlide++;
        this.setSlide(this._currentSlide);
        this.dotActivation(this._currentSlide);
    }
    prevSlide() {
        if (this._currentSlide === 0) this._currentSlide = this._maxSlide - 1;
        else this._currentSlide--;
        this.setSlide(this._currentSlide);
        this.dotActivation(this._currentSlide);
    }
    createDots() {
        this._slides.forEach((_, index)=>{
            this._dots.insertAdjacentHTML("beforeend", `<button class="dots__dot" data-slide="${index}"></button>`);
        });
    }
    dotActivation(slide) {
        const dots = [
            ...this._dots.querySelectorAll(".dots__dot")
        ];
        dots.forEach((dot)=>{
            dot.classList.remove("dots__dot--active");
            dot.dataset.slide === `${slide}` ? dot.classList.add("dots__dot--active") : dot.classList.remove("dots__dot--active");
        });
        this._dots.addEventListener("click", this.dotsHandler.bind(this));
    }
    dotsHandler(e) {
        if (e.target.classList.contains("dots__dot")) {
            const { slide: slide } = e.target.dataset;
            this.setSlide(slide);
            this.dotActivation(slide);
        }
    }
    keydownHandler(e) {
        e.key === "ArrowLeft" && this.prevSlide();
        e.key === "ArrowRight" && this.nextSlide();
    }
}
const $d529ab21baf1a41a$var$slider = new $d529ab21baf1a41a$var$Slider();


//# sourceMappingURL=index.b16e4c39.js.map
